export enum ValueType {
  BTC = 'BTC',
  ETH = 'ETH',
  USD = 'USD',
  AUD = 'AUD',
}

export type MonetaryValue = {
  currency: ValueType;
  amount: number;
};
